import React, { Component } from 'react';
import c3 from 'c3';
import 'c3/c3.css';
import './chart.css';
import { isEmpty } from '../Common/Common';

export default class Chart_Bar extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}

		this.chart = null;
	}

	componentDidMount() {
		this.generateChart();
		window.addEventListener('resize', this.generateChart);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.generateChart);
	}

	loadChart = () => {
		this.chart.load({
			columns: this.props.data,
		})
	}

	generateChart = () => {
		let width = this.props.chart_width;
		let height = this.props.chart_height;

		let colors = {};
		if (!isEmpty(this.props.colors)) colors = this.props.colors;

		this.chart = c3.generate({
			bindto: "#chart_" + this.props.id,
			size: {
				width: width,
				height: height,
			},
			data: {
				x: 'x',
				xFormat: '%m%d %H:%M', // 'xFormat' can be used as custom format of 'x'
				columns: this.props.data,
				type: 'bar',
				colors: colors,
			},
			axis: {
				x: {
					type: 'timeseries',
					tick: {
						format: '%H:%M'
					}
				}
			},
			title: {
				text: this.props.title,
				position: 'top-center',   // top-left, top-center and top-right
			},
		})

		return this.chart;
	}

	render() {
		let style = {};
		style = Object.assign(style, this.props.style);

		return (
			<div id={"chart_" + this.props.id} style={style} />
		);
	}
}